import { FillMode } from '@tencent/alloy-graphics';
import { STPathFillMode } from '@tencent/slide-sdk-model';

// 路径填充方式 - sdk对上层类型映射
export const PATH_FILL_TYPE_MAP = new Map([
    [STPathFillMode?.none, FillMode.NONE],
    [STPathFillMode?.darken, FillMode.DARKER],
    [STPathFillMode?.norm, FillMode.NORMAL],
    [STPathFillMode?.lighten, FillMode.BRIGHTER],
    [STPathFillMode?.darkenLess, FillMode.DARK],
    [STPathFillMode?.lightenLess, FillMode.BRIGHT],
]);
